<span
  class="munily-tooltip-trigger"
  [matTooltip]="text"
  [matTooltipPosition]="position"
  [matTooltipDisabled]="disabled"
  [matTooltipClass]="panelClasses"
  tabindex="0"
  [attr.aria-label]="text"
>
  <mat-icon class="munily-tooltip-trigger__icon material-symbols-rounded">{{ icon }}</mat-icon>
</span>
